import authInstance from "../Interceptor";

export const AddProductEffect = (productData, config) => {
  return authInstance.post("/products/add", productData, config);
};

export const EditProductEffect = (productId, updatedData) => {
  return authInstance.put(`/products/update/${productId}`, updatedData);
};

export const DeleteProductEffect = (productId) => {
  return authInstance.delete(`/products/delete/${productId}`);
};

export const ViewProductEffect = (productId) => {
  return authInstance.get(`/products/get?product_id=${productId}`);
};

export const ViewAllProductsEffect = (payload) => {
  return authInstance.get(
    `/products/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewProductsByBrandIdEffect = (brandId) => {
  return authInstance.get(`/products/getProductbybrandid?brand_id=${brandId}`);
};

export const ViewAllSearchProductsEffect = () => {
  return authInstance.get(`/products/list`);
};
